import Container from '@/components/Container';
import HeadingOne from '@/components/Heading/HeadingOne';
import PageHead from '@/components/PageHead';
import PageLayout from '@/components/layout/page-layout';
import { useState } from 'react';
import NextLink from 'next/link';
import Modal from '@/components/ModalDocuments';
import Portal from '@/components/Portal';

export default function Page() {
	const [isOpenModalEstatuto, setIsOpenModalEstatuto] = useState(false);
	const [isOpenModalRelatorioAtividades2022, setIsOpenRelatorioAtividades2022] = useState(false);
	const [isOpenModalRelatorioAtividades2023, setIsOpenRelatorioAtividades2023] = useState(false);
	const [isOpenModalRelatorioAtividades2024, setIsOpenRelatorioAtividades2024] = useState(false);
	const [isOpenModalRelatorioAtividades2025, setIsOpenRelatorioAtividades2025] = useState(false);

	return (
		<>
			<PageHead
				page={{
					title: 'Instituto Deixe Vivo - Transparência',
					keywords:
						'OSC, Instituto, Deixe Vivo, Doação de órgãos e tecidos, transplantes, renal, tecidos, transparência',
					colorScheme: 'light dark',
					description: 'Instituto Deixe Vivo',
					robots: 'nofollow, noindex',
				}}
				og={{
					description: 'Instituto Deixe Vivo - Transparência',
					site_name: 'Instituto Deixe Vivo - Transparência',
					title: 'Instituto Deixe Vivo - Transparência',
					type: 'website',
					url: 'https://deixevivo.org.br',
					image: {
						alt: 'Logo do Instituto, ao lado esquerdo da imagem um rosto feliz e ao lado direito texto que diz Instituto Deixe Vivo',
						fbAdmins: 'instituto.deixevivo',
						src: 'https://res.cloudinary.com/oliveiradev/image/upload/v1681919729/InstitutoDeixeVivo/logos/logo-deixe-vivo-1200x1200.jpg',
						type: 'image/jpg',
						width: '1200',
						height: '1200',
					},
				}}
				twitter={{
					card: 'summary',
					description: 'Instituto Deixe Vivo - Quem faz acontecer',
					site: 'Instituto Deixe Vivo - Quem faz acontecer',
					title: 'Instituto Deixe Vivo - Quem faz acontecer',
					url: 'https://deixevivo.org.br',
					image: {
						alt: 'Logo do Instituto, ao lado esquerdo da imagem um rosto feliz e ao lado direito texto que diz Instituto Deixe Vivo',
						src: 'https://res.cloudinary.com/oliveiradev/image/upload/v1681919729/InstitutoDeixeVivo/logos/logo-deixe-vivo-1200x1200.jpg',
					},
				}}
			/>

			<PageLayout>
				<Container className="py-8">
					<HeadingOne horizontalRow>Transparência</HeadingOne>
					<section className="my-4">
						<article>
							<h2>
								<NextLink
									href="#"
									onClick={(_) => setIsOpenModalEstatuto(true)}
									className="underline text-blue-500"
								>
									Estatuto Social
								</NextLink>
							</h2>
							{isOpenModalEstatuto && (
								<Portal>
									<Modal
										title="Estatuto Social"
										isOpen={isOpenModalEstatuto}
										setIsOpen={setIsOpenModalEstatuto}
										src="/assets/docs/Associação_Deixe_Vivo_-_Estatuto_registrado.pdf"
									/>
								</Portal>
							)}
						</article>
						<article className="mt-2">
							<h2>
								<NextLink
									href="#"
									onClick={(_) => setIsOpenRelatorioAtividades2022(true)}
									className="underline text-blue-500"
								>
									Relatório de Atividades (2022)
								</NextLink>
							</h2>
							{isOpenModalRelatorioAtividades2022 && (
								<Portal>
									<Modal
										title="Relatório de Atividades (2022)"
										isOpen={isOpenModalRelatorioAtividades2022}
										setIsOpen={setIsOpenRelatorioAtividades2022}
										src="/assets/docs/relatorio-de-atividades-de-2022.pdf"
									/>
								</Portal>
							)}
						</article>
						<article className="mt-2">
							<h2>
								<NextLink
									href="#"
									onClick={(_) => setIsOpenRelatorioAtividades2023(true)}
									className="underline text-blue-500"
								>
									Relatório de Atividades (2023)
								</NextLink>
							</h2>
							{isOpenModalRelatorioAtividades2023 && (
								<Portal>
									<Modal
										title="Relatório de Atividades (2023)"
										isOpen={isOpenModalRelatorioAtividades2023}
										setIsOpen={setIsOpenRelatorioAtividades2023}
										src="/assets/docs/relatorio-de-atividades-de-2023.pdf"
									/>
								</Portal>
							)}
						</article>
						<article className="mt-2">
							<h2>
								<NextLink
									href="#"
									onClick={(_) => setIsOpenRelatorioAtividades2024(true)}
									className="underline text-blue-500"
								>
									Relatório de Atividades (2024)
								</NextLink>
							</h2>
							{isOpenModalRelatorioAtividades2024 && (
								<Portal>
									<Modal
										title="Relatório de Atividades (2024)"
										isOpen={isOpenModalRelatorioAtividades2024}
										setIsOpen={setIsOpenRelatorioAtividades2024}
										src="/assets/docs/relatorio-de-atividades-de-2024.pdf"
									/>
								</Portal>
							)}
						</article>
						<article className="mt-2">
							<h2>
								<NextLink
									href="#"
									onClick={(_) => setIsOpenRelatorioAtividades2025(true)}
									className="underline text-blue-500"
								>
									Relatório de Atividades (2025)
								</NextLink>
							</h2>
							{isOpenModalRelatorioAtividades2025 && (
								<Portal>
									<Modal
										title="Relatório de Atividades (2025)"
										isOpen={isOpenModalRelatorioAtividades2025}
										setIsOpen={setIsOpenRelatorioAtividades2025}
										src="/assets/docs/relatorio-de-atividades-de-2025.pdf"
									/>
								</Portal>
							)}
						</article>
					</section>
				</Container>
			</PageLayout>
		</>
	);
}
